/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LogAccessResponseDto } from '../../models/log-access-response-dto';
import { LogDocumentAccessDto } from '../../models/log-document-access-dto';

export interface DocumentAccessLogControllerLogDocumentView$Params {

/**
 * Tenant ID
 */
  tenant: string;

/**
 * Document ID
 */
  documentId: string;
      body: LogDocumentAccessDto
}

export function documentAccessLogControllerLogDocumentView(http: HttpClient, rootUrl: string, params: DocumentAccessLogControllerLogDocumentView$Params, context?: HttpContext): Observable<StrictHttpResponse<LogAccessResponseDto>> {
  const rb = new RequestBuilder(rootUrl, documentAccessLogControllerLogDocumentView.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('documentId', params.documentId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LogAccessResponseDto>;
    })
  );
}

documentAccessLogControllerLogDocumentView.PATH = '/thalea-documents/access-logs/{tenant}/documents/{documentId}/view';
